import { render, staticRenderFns } from "./ResetRealityButton.vue?vue&type=template&id=708824d8&scoped=true"
import script from "./ResetRealityButton.vue?vue&type=script&lang=js"
export * from "./ResetRealityButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708824d8",
  null
  
)

export default component.exports